import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { FlexColumn } from 'core/components';
import { injectStores } from 'app/util/injectStores';
import { useDeviceLookupByName } from 'app/util/lookups/deviceIndex';
import Topology from './Topology';
import EmbeddedTopo from './EmbeddedTopo';

interface DeviceTopologyProps extends Partial<RouteComponentProps<{ deviceName: string }>> {
  $topo: {
    getTopologyData: (props: {
      selectedDeviceName?: string;
      type: string;
      level: string;
      showProviders: string;
    }) => void;
    navigateToDeviceTopo: (deviceName?: string) => void;
  };
  deviceName?: string;
  embedded?: boolean;
  expandable?: boolean;
}

const DeviceTopology = ({
  $topo,
  deviceName: deviceNameProp,
  match,
  embedded = false,
  expandable
}: DeviceTopologyProps) => {
  const deviceName = deviceNameProp || match?.params.deviceName;
  // only needed for the device id in the hybrid map link
  const { data: device } = useDeviceLookupByName(deviceName);

  useEffect(() => {
    $topo.getTopologyData({
      selectedDeviceName: deviceName,
      type: 'device',
      level: 'device',
      showProviders: 'name'
    });
  }, [$topo, deviceName]);

  return (
    <FlexColumn height="100%">
      {embedded && <EmbeddedTopo onOpen={() => $topo.navigateToDeviceTopo(deviceName)} expandable={expandable} />}
      {!embedded && <Topology title={deviceName} deviceId={device?.id} />}
    </FlexColumn>
  );
};

export default injectStores('$topo')(DeviceTopology);
